import React from 'react'
import { CardMedia, Card } from '@mui/material'

export default ({ src }) => {
    return (
        <>
            {src ? (
                <Card
                    sx={{
                        '& .MuiCardMedia-img': {
                            objectFit: 'contain',
                            height: '110px',
                            padding: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            boxSizing: 'border-box',
                        },
                    }}
                >
                    <CardMedia
                        className={'pandium-logo'}
                        src={src}
                        component="img"
                        onError={(ev) => {
                            ev.target.style = 'display:none'
                        }}
                    />
                </Card>
            ) : (
                <span> </span>
            )}
        </>
    )
}
